/**
 * NOTE:
 *
 * This file is automatically generated by i18n-tools.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
// Icelandic
export default {
  'fabric.mention.unknow.user.error': 'Óþekktur notandi {userId}',
  'fabric.mention.noAccess.warning': '{name} mun ekki fá tilkynningu þar sem þeir hafa ekki aðgang',
  'fabric.mention.noAccess.label': 'Enginn aðgangur',
  'fabric.mention.error.defaultHeadline': 'Eitthvað fór úrskeiðis',
  'fabric.mention.error.defaultAction': 'Reyndu aftur eftir nokkrar sekúndur',
  'fabric.mention.error.loginAgain': 'Reyndu að skrá þig út og svo inn aftur',
  'fabric.mention.error.differentText': 'Reyndu að slá inn annan texta',
  'fabric.elements.mentions.team.member.count': '{0, plural, one{Einn meðlimur} other{{0} meðlimir}}',
  'fabric.elements.mentions.team.member.count.including.you': '{0, plural, one{{0} meðlimir, að þér meðtöldum/meðtalinni} other{{0} meðlimir, að þér meðtöldum/meðtalinni}}',
  'fabric.elements.mentions.team.member.50plus': '50+ meðlimir',
  'fabric.elements.mentions.team.member.50plus.including.you': '50+ meðlimir, að þér meðtöldum/meðtalinni',
  'fabric.elements.mentions.team.mention.highlight.title': 'Nefna teymi þinn',
  'fabric.elements.mentions.team.mention.highlight.description': 'Fáðu alla til að koma á síðuna með einum smelli. Ekkert teymi?',
  'fabric.elements.mentions.team.mention.highlight.description.link': 'Hefja eina.',
  'fabric.elements.mentions.team.meantion.highlight.close.button.tooltip': 'Hafna'
};